import moment from 'moment'

export const transParmasBypostToGet = function (realUrl, obj) {
  var url = realUrl + '?'; // 提前加好问号
  for(var name in obj){
    url += name + '=' + encodeURIComponent(obj[name]) + '&'; // 转码并进行赋值
  }
  url = url.substring(0,url.length-1); // 去掉最后一个&符号
  return url; // 返回
}

export function getObjProperty(obj, str) {
  str = str.replace(/\[(\w+)\]/g, ".$1"); // 处理数组下标
  let arr = str.split(".");
  for (let i in arr) {
    obj = obj[arr[i]] || "";
  }
  return obj;
}

export function processLastChildrens(arr) {
  for (var i in arr) {
    var obj = arr[i];
    if (!obj.children) {
      continue;
    }
    var findResult = processLastChildrens(obj.children);
    if (!findResult) {
      obj.children = null;
      findResult = true;
    }
  }
  return findResult;
}

/*
* 根据类型处理结束时间格式
* */
export function formatRangeDateByType(startDate, type) {
  var isDate = Object.prototype.toString.call(startDate) === '[object Date]';
  var time = isDate ? startDate : new Date(startDate);
  var format = 'YYYY-MM-DD';
  return [moment(time).startOf(type).format(format), moment(time).endOf(type).format(format)]
}

export function formatRangeMakeupTime(range){
  var start = range[0];
  var end = range[1];
  return [start+' 00:00:00', end+' 23:59:59'];
}